/**
 * taskModuleMenuKeys - Chaves de menu (permissões por perfil) de cada módulo de tarefas.
 *
 * Tarefas, Retenção e Jurídico compartilham as mesmas telas, mas as permissões são
 * SEPARADAS: o Jurídico nunca deve depender das chaves `tasks_*` (e vice-versa).
 *
 * RELEASE: 2026-10-22 v1.0.0 - Criação: fonte única das chaves por módulo.
 */
import type { TaskModuleType } from '@/hooks/useTaskModuleType';

export interface TaskModuleMenuKeys {
  list: string;
  kanban: string;
  phases: string;
  dashboard: string;
}

const KEYS: Record<TaskModuleType, TaskModuleMenuKeys> = {
  normal: { list: 'tasks_list', kanban: 'tasks_kanban', phases: 'tasks_phases', dashboard: 'tasks_dashboard' },
  retention: { list: 'retention_list', kanban: 'retention_kanban', phases: 'retention_phases', dashboard: 'retention_dashboard' },
  legal: { list: 'legal_list', kanban: 'legal_kanban', phases: 'legal_phases', dashboard: 'legal_dashboard' },
};

/** Retorna as chaves de menu do módulo informado (padrão: Tarefas). */
export function getTaskModuleMenuKeys(type: TaskModuleType | null | undefined): TaskModuleMenuKeys {
  return KEYS[type ?? 'normal'] ?? KEYS.normal;
}
